import { type AggregatedNumberBreakdown, type NumberBreakdown } from "./types";

/**
 * Aggregates number breakdowns into a list of aggregated numbers with percentages.
 */
export function aggregateBreakdowns(
  breakdowns: NumberBreakdown[],
  defaultValues: number[] = []
): AggregatedNumberBreakdown[] {
  const counts: Record<number, number> = defaultValues.reduce<Record<number, number>>(
    (accumulator, value) => {
      accumulator[value] = 0;
      return accumulator;
    },
    {}
  );

  const totalRatings = breakdowns.reduce((sum, breakdown) => sum + breakdown.count, 0);

  breakdowns.forEach((breakdown) => {
    counts[breakdown.value] = (counts[breakdown.value] ?? 0) + breakdown.count;
  });

  return Object.entries(counts)
    .map(([value, count]) => ({
      value: Number(value),
      percentage: totalRatings > 0 ? (count / totalRatings) * 100 : 0,
    }))
    .sort((a, b) => b.value - a.value);
}
